// Type Imports
import type { ChildrenType, Direction } from '@core/types'

// Context Imports
import { VerticalNavProvider } from '@menu/contexts/verticalNavContext'
import { SettingsProvider } from '@core/contexts/settingsContext'
import ThemeProvider from '@components/theme'

// Util Imports
import { getMode, getSettingsFromStorage, getSystemMode } from '@core/utils/serverHelpers'
import TanstackProviders from '@/providers/TanstackProviders'
import ClientProvider from '@components/ClientProvider'

type Props = ChildrenType & {
  direction: Direction
}

const Providers = (props: Props) => {
  // Props
  const { children, direction } = props

  // Vars
  const mode = getMode()
  const settingsCookie = getSettingsFromStorage()
  const systemMode = getSystemMode()

  return (
    <TanstackProviders>
      <VerticalNavProvider>
        <SettingsProvider settingsCookie={settingsCookie} mode={mode}>
          <ThemeProvider direction={direction} systemMode={systemMode}>
            <ClientProvider>{children}</ClientProvider>
          </ThemeProvider>
        </SettingsProvider>
      </VerticalNavProvider>
    </TanstackProviders>
  )
}

export default Providers
